module.exports = __webpack_public_path__ + "static/media/sketches.7477c8ec.jpg";